module.exports = __webpack_public_path__ + "static/media/haute10B.170632cd.jpg";